import Vue from 'vue';
import VueAppInsights from './AppInsights'

export default function setupAppInsights(id, router) {
  Vue.use(VueAppInsights, {
    baseName: 'wfc-frontend',
    id,
    router,
    disableFetchTracking: false,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
  })
};
